import InvitedPerson from './InvitedPerson.vue';

export default InvitedPerson;



// WEBPACK FOOTER //
// ./src/pages/profile/blocks/children/sidebar/components/invitedperson/index.ts